import { FunctionComponent, useEffect } from 'react'
import { Box, Responsive } from '@careguide/theme'
import {
  ModalContentProps,
  CloseContainer,
  Content,
  Background,
  contentDimension,
  CloseButton,
} from './Modal.style'
import theme from '@careguide/theme'
import Portal from '../Portal/Portal'

type ModalProps = {
  showModal: boolean
  onCloseModal: () => void
  contentBackgroundColor?: string
  shouldCloseOnEsc?: boolean
  disableClose?: boolean
  backgroundOpaciy?: number
  fitContent?: boolean
  width?: Responsive<string>
}

const Modal: FunctionComponent<ModalProps & ModalContentProps> = ({
  onCloseModal,
  showModal,
  children,
  contentBackgroundColor,
  shouldCloseOnEsc,
  disableClose = false,
  backgroundOpacity = 0.65,
  fitContent = false,
  width,
  ...otherProps
}) => {
  useEffect(() => {
    const close = (e: TODO) => {
      if (e.keyCode === 27 || e.key === 'Escape') {
        if (shouldCloseOnEsc && !disableClose) {
          onCloseModal()
        }
      }
    }

    window.addEventListener('keydown', close)

    return () => window.removeEventListener('keydown', close)
  }, [shouldCloseOnEsc, disableClose])

  return (
    <Portal>
      {showModal && (
        <Box>
          <Box
            display='flex'
            position='fixed'
            bottom='0'
            left='0'
            right='0'
            top='0'
            alignItems='center'
            justifyContent='center'
            overflow='hidden'
            width='100vw'
            zIndex={theme.zIndex.modal}
          >
            <Box>
              <Background onClick={onCloseModal} $backgroundOpacity={backgroundOpacity} />
              <Content
                overflow='auto'
                position='relative'
                width={width ? width : contentDimension}
                height={fitContent ? 'auto' : contentDimension}
                p={{ _: 4 }}
                $contentBackgroundColor={contentBackgroundColor}
                maxHeight='80vh'
                {...otherProps}
              >
                {!disableClose && (
                  <CloseContainer p='0px 0px 2px'>
                    <CloseButton fillColor='black' aria-hidden='true' onClick={onCloseModal} />
                  </CloseContainer>
                )}
                <Box>{children}</Box>
              </Content>
            </Box>
          </Box>
        </Box>
      )}
    </Portal>
  )
}

export default Modal
